import React, { useRef, useState, useEffect, useContext  } from "react";
import * as S from "./FlorenzTextArea.style.js";
import * as P from "../../../utils/pipes";
import { ThemeContext } from 'styled-components';
import { useTranslation } from "react-i18next";

function  FlorenzTextArea({ 
  placeholder, 
  icon,
  value,
  getText,
  disabled,
  ...props
}) {  
  const container = useRef(null);
  const textInput = useRef(null);
  const [active, setActive] = useState(false);
  const theme = useContext(ThemeContext);

  const {i18n: { language }} = useTranslation("global");
  const [activedMic, setActivedMic] = useState(false);
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const [ recognition ] = useState(SpeechRecognition ? new SpeechRecognition() : null);


  const btnStopRecord = () => {
    recognition.stop();
    setActivedMic(false);
  };

  const btnStartRecord = () => {
    const languageSetting = P.getMicLanguage(language);
    recognition.lang = languageSetting;
    recognition.continuous = true;
    recognition.start();
    recognition.onresult = (event) => {
      const results = event.results;
      const frase = results[results.length - 1][0].transcript;
      value += ' ' + frase;
      getText(value);
    }
    setActivedMic(true);
  };


  useEffect(() => {
    const handleClickOutside = e => {
      if (!container.current.contains(e.target)) {
        setActive(false)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const activeInput = () => {
    if (!disabled) {
      textInput.current.focus(); 
      setActive(true);
    } 
  } 

  return (
    <S.FlorenzTextArea
      active={active} 
      disabled={disabled} 
    >
        <div className="input-container" onClick={() => activeInput()} ref={container}>
          {
            icon && <i className={'icon-input-form icon zaia-' + icon} style={{ color: active ? theme.inputSelected : theme.inputPlaceholder }} />
          }
          {
            SpeechRecognition && 
            <>
              <div className='mic-container' onClick={() => !activedMic ? btnStartRecord() : btnStopRecord()}>
                <i className='mic-icon icon zaia-microphone'/>
              </div>
            </>
          }
          {
            <textarea 
              ref={textInput}
              placeholder={placeholder} 
              onChange={(event) => getText(event.target.value)}
              value={value}
              {...props}
            />
          }
        </div>
    </S.FlorenzTextArea>
  );
}

export default FlorenzTextArea;
